import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { SignedDocumentsView } from "@containers/signedDocuments/SignedDocumentsView";

const SignedSessionsPage = () => {
    return (
        <AuthenticatedLayout activeMenuItem="signedDocuments">
            <SignedDocumentsView />
        </AuthenticatedLayout>
    );
}

export default SignedSessionsPage;